import config from '../config/config';
import { joinApiUrl } from '../config/api-url';

(function (global) {
  "use strict";

  var state = {
    started: false,
    loading: false,
    effective: null,
    apiBase: "",
    startAttempts: 0
  };

  function resolveApiBase() {
    return joinApiUrl(config.API_URL, 'api');
  }

  function hasHttpClient() {
    return !!(
      global.GLOBALAXIOS ||
      global.axios
    );
  }

  function hasToken() {
    try {
      if (
        typeof global.getOzgUserToken === "function"
      ) {
        var token =
          String(
            global.getOzgUserToken() || ""
          ).trim();

        if (token) {
          return true;
        }
      }
    } catch (e) {}

    try {
      var app =
        global.GlobalVueInstance &&
        global.GlobalVueInstance.$root &&
        global.GlobalVueInstance.$root.$children &&
        global.GlobalVueInstance.$root.$children[0];

      var appToken =
        String(
          (
            app &&
            app.userData &&
            app.userData.token
          ) ||
          (
            app &&
            app.token
          ) ||
          ""
        ).trim();

      if (appToken) {
        return true;
      }
    } catch (e) {}

    return !!String(
      global.localStorage.getItem("ozgUserJwt") ||
      global.localStorage.getItem("ozgJwt") ||
      ""
    ).trim();
  }

  async function loadEffective() {
    if (state.loading) {
      return state.effective;
    }

    if (!global.OzgPackageGate) {
      throw new Error(
        "OzgPackageGate ist nicht verfügbar."
      );
    }

    state.loading = true;

    try {
      state.effective =
        await global.OzgPackageGate.loadEffective(
          state.apiBase || resolveApiBase(),
          "manager",
          null
        );

      global.__ozgEffectivePackages =
        state.effective;

      if (
        typeof global.OzgPackageGate.applyDomRules ===
        "function"
      ) {
        global.OzgPackageGate.applyDomRules(
          state.effective
        );
      }

      return state.effective;
    } finally {
      state.loading = false;
    }
  }

  async function start(apiBase) {
    state.apiBase =
      String(
        apiBase || resolveApiBase()
      ).replace(/\/$/, "");

    if (state.started) {
      return state;
    }

    state.started = true;

    try {
      await loadEffective();

      console.info(
        "[PACKAGE] Paket-Gating im Manager initialisiert."
      );
    } catch (e) {
      console.warn(
        "[PACKAGE] Effektive Pakete konnten nicht geladen werden.",
        e
      );
    }

    return state;
  }

  async function reload() {
    try {
      return await loadEffective();
    } catch (e) {
      console.warn(
        "[PACKAGE] Paketkontext konnte nicht neu geladen werden.",
        e
      );

      return null;
    }
  }

  function autoStart() {
    if (state.started) {
      return;
    }

    state.startAttempts += 1;

    if (
      !global.OzgPackageGate ||
      !hasHttpClient() ||
      !hasToken()
    ) {
      if (state.startAttempts <= 120) {
        global.setTimeout(
          autoStart,
          500
        );
      } else {
        console.error(
          "[PACKAGE] Automatischer Paket-Gating-Start abgebrochen."
        );
      }

      return;
    }

    start(
      resolveApiBase()
    ).catch(function (e) {
      state.started = false;

      console.error(
        "[PACKAGE] Automatischer Paket-Gating-Start fehlgeschlagen",
        e
      );

      global.setTimeout(
        autoStart,
        1000
      );
    });
  }

  global.OzgPackageBootstrap = {
    start: start,
    reload: reload,
    loadEffective: loadEffective,
    autoStart: autoStart,
    state: state
  };

  if (
    document.readyState === "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      autoStart
    );
  } else {
    global.setTimeout(
      autoStart,
      0
    );
  }
})(window);
